var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[_c('div',{staticStyle:{"flex":"18"}},[_c('span',[_vm._v(" "+_vm._s(_vm.t(_vm.$route.meta.title)))]),(_vm.$slots.btn)?_vm._t("btn"):_vm._e()],2),(_vm.$slots.subject)?_vm._t("subject"):_vm._e(),(_vm.$slots.back)?_vm._t("back"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }